import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectors as bookmakersListSelectors } from '../../common/bookmakersList';
import { selectors as transitionRouterSelectors } from '../../common/transitionRouter';
import BookmakerLink from '../bookmakerLink';
import './styles.scss';

export const ForgottenPassword = ({
    forgottenBookmakerName,
    forgottenPhoneNumber,
    forgottenBookmakerUrl,
    isPhone,
}) => (
    <div className="bs-forgottenPassword">
        <div className="bs-forgottenPassword__title bs-popover__title">
            Forgotten Password
        </div>
        <BookmakerLink
            titleText="Call to retrieve your password"
            phoneNumber={forgottenPhoneNumber}
            isPhone={isPhone}
        />
        <BookmakerLink
            titleText={`Or visit ${forgottenBookmakerName}`}
            bookmakerUrl={forgottenBookmakerUrl}
            bookmakerName={forgottenBookmakerName}
        />
    </div>
);

ForgottenPassword.defaultProps = {
    isPhone: true,
    forgottenPhoneNumber: '',
    forgottenBookmakerName: '',
    forgottenBookmakerUrl: null,
};

ForgottenPassword.propTypes = {
    isPhone: PropTypes.bool,
    forgottenBookmakerName: PropTypes.string,
    forgottenPhoneNumber: PropTypes.string,
    forgottenBookmakerUrl: PropTypes.string,
};

const bookmakerInfoSelector =
    bookmakersListSelectors.createBookmakerInfoSelector(
        transitionRouterSelectors.feedSelector,
    );

const mapStateToProps = (state, props) => {
    const { isPhone } = state.pageInfo;
    return {
        isPhone,
        ...bookmakerInfoSelector(state, props),
    };
};

export default connect(
    mapStateToProps,
    null,
)(ForgottenPassword);



// WEBPACK FOOTER //
// /src/js/common/forgottenPassword/ForgottenPassword.jsx